import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSaveProductIconWhite = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "#001489",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_7410_4046)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 16,
					height: 16,
					fill: "#001489",
					stroke: ""
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.5 15.5H1.5C1.23478 15.5 0.98043 15.3946 0.792893 15.2071C0.605357 15.0196 0.5 14.7652 0.5 14.5V3.82867C0.500113 3.29828 0.710901 2.78965 1.086 2.41467L2.414 1.086C2.59975 0.90019 2.8203 0.752801 3.06303 0.652253C3.30577 0.551705 3.56593 0.499969 3.82867 0.5C4.0914 0.500031 14.5 0.5 14.5 0.5C14.7652 0.5 15.0196 0.605357 15.2071 0.792893C15.3946 0.98043 15.5 1.23478 15.5 1.5V14.5C15.5 14.7652 15.3946 15.0196 15.2071 15.2071C15.0196 15.3946 14.7652 15.5 14.5 15.5Z",
					stroke: "white",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4.5 0.5V3.5C4.5 3.76522 4.60536 4.01957 4.79289 4.20711C4.98043 4.39464 5.23478 4.5 5.5 4.5H10.5C10.7652 4.5 11.0196 4.39464 11.2071 4.20711C11.3946 4.01957 11.5 3.76522 11.5 3.5V0.5",
					stroke: "white",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.5 8.5H4.5C4.23478 8.5 3.98043 8.60536 3.79289 8.79289C3.60536 8.98043 3.5 9.23478 3.5 9.5V15.5H12.5V9.5C12.5 9.23478 12.3946 8.98043 12.2071 8.79289C12.0196 8.60536 11.7652 8.5 11.5 8.5Z",
					stroke: "white",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_7410_4046",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "#001489"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgSaveProductIconWhite);
export default ForwardRef;
